import { render, staticRenderFns } from "./activity-look.vue?vue&type=template&id=c887d908&scoped=true&"
import script from "./activity-look.vue?vue&type=script&lang=js&"
export * from "./activity-look.vue?vue&type=script&lang=js&"
import style0 from "./activity-look.vue?vue&type=style&index=0&id=c887d908&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c887d908",
  null
  
)

export default component.exports